import {
    useCallback,
} from 'react'

import Typeahead from 'app/shared-components/Typeahead'
import useGetOpportunityById from 'app/Apps/AccountManagement/Opportunities/hooks/useGetOpportunityById'
import useOpportunityLoadOptions from './hooks/useOpportunityLoadOptions'
import {
    OpportunityFilters,
} from './OpportunititesSelector.types'

type Props = {
    name?: string,
    value?: {
        id: number,
    },
    onChange: (value: { id: number }) => void,
    title?: string,
    disabled?: boolean,
    className?: string,
    required?: boolean,
    includeFilters?: OpportunityFilters
}

const defaultProps: Partial<Props> = {
    name: '',
    value: undefined,
    title: 'Opportunity Number',
    disabled: false,
    className: '',
    required: false,
    includeFilters: {
        accountId: [undefined],
        temperatureRange: [undefined],
    },
}

const OpportunitiesSelector = ({
    name,
    value,
    onChange,
    title,
    className,
    disabled,
    required,
    includeFilters,
}: Readonly<Props>) => {
    const {
        data: labelData,
    } = useGetOpportunityById(value?.id)

    const loadOptions = useOpportunityLoadOptions()

    const onChangeValue = useCallback((newValue) => {
        const convertedValue = newValue ? {
            id: newValue,
        } : undefined

        onChange(convertedValue)
    }, [onChange])

    const loadOptionsWithFilters = useCallback((searchFilters) => {
        if (!includeFilters.accountId[0] || !includeFilters.temperatureRange[0]) {
            return loadOptions(searchFilters)
        }
        return loadOptions({
            ...searchFilters,
            filters: includeFilters,
        })
    }, [
        includeFilters,
        loadOptions,
    ])

    return (
        <Typeahead
            name={name}
            title={title}
            className={className}
            onChange={onChangeValue}
            loadOptions={loadOptionsWithFilters}
            labelData={labelData}
            labelField="opportunityNumber"
            value={value?.id}
            disabled={disabled}
            isRequired={required}
        />
    )
}

OpportunitiesSelector.defaultProps = defaultProps

export default OpportunitiesSelector
